function NotFound() {
  return <h1>404 - Page introuvable</h1>;
}

export default NotFound;